import {
    SET_CALL_VIEW,
    SET_CALL_REGISTRATION
} from '../../../helpers/action-types';

const initialState = {
    view: '',
    registration: {
        view_type: '',
        login_type: '',
        userIdentificationNumber: '',
        categoryLine: null,
        categorySegment: null,
        categoryId: null
    }
};

const reducer = (state = initialState, action = { type: null }) => {
    switch (action.type) {
        case SET_CALL_VIEW:
            return {
                ...state,
                view: action.view
            };

        case SET_CALL_REGISTRATION:
            return {
                ...state,
                registration: {
                    ...state.registration,
                    ...action.registration
                }
            };

        default:
            return state;
    }
};

export default reducer;
